import AgeBanner from "../components/AgeBanner";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";
import { usePageTitle } from "../hook/usePageTitle";

const DisclaimerPage = () => {
    usePageTitle("Disclaimer");
    return (
        <>
            <AgeBanner />
            <Navigation />
            <div className="policy-page">
                <div className="policy-hero">
                    <h1><span className="highlight">Disclaimer</span></h1>
                </div>

                <div className="policy-content">
                    <p className="last-updated">Last Updated: January 28, 2026</p>

                    <h2>Entertainment Purpose Only</h2>
                    <p>Zonvex and all games available on this platform are created purely for <strong>entertainment
                        purposes</strong>. This is a social casino platform that offers simulated casino-style games. No
                        real money gambling takes place on this website.</p>

                    <h2>No Real Money Involved</h2>
                    <p>All virtual currency, coins, credits, or any other form of in-game value used on Zonvex has
                        <strong>no real-world monetary value</strong>. These items cannot be:</p>
                    <ul>
                        <li>Exchanged for real money or cash</li>
                        <li>Converted to cryptocurrency or any digital currency</li>
                        <li>Transferred to other users for monetary consideration</li>
                        <li>Used as payment for goods or services</li>
                        <li>Redeemed for prizes or rewards with real value</li>
                    </ul>

                    <h2>No Prizes or Winnings</h2>
                    <p>There are <strong>no prizes, winnings, or payouts</strong> associated with gameplay on Zonvex. Any
                        virtual rewards, achievements, or credits earned through gameplay are for entertainment and progression
                        purposes only.</p>

                    <h2>Age Requirement</h2>
                    <p>Zonvex is intended for users who are <strong>18 years of age or older</strong>. By accessing and
                        using this platform, you confirm that you meet this age requirement. We reserve the right to restrict
                        access to users who do not comply with this requirement.</p>

                    <h2>Not a Gambling Platform</h2>
                    <p>Zonvex is <strong>not a gambling platform</strong>. The games presented here simulate the
                        experience of casino-style entertainment without the financial aspects associated with real gambling.
                        There is no opportunity to win or lose real money.</p>

                    <h2>Responsible Gaming</h2>
                    <p>While Zonvex does not involve real money, we encourage all users to engage with our platform
                        responsibly:</p>
                    <ul>
                        <li>Set time limits for your gaming sessions</li>
                        <li>Take regular breaks during extended play</li>
                        <li>Remember that games are meant for entertainment</li>
                        <li>If gaming ever stops being fun, take a break</li>
                    </ul>

                    <h2>No Guarantee of Outcomes</h2>
                    <p>Game outcomes on Zonvex are determined by random number generators (RNG) for entertainment
                        purposes. Past results do not guarantee or indicate future outcomes. The simulated nature of our games
                        means there is no skill-based advantage or strategy that guarantees specific results.</p>

                    <h2>Intellectual Property</h2>
                    <p>All content on Zonvex, including but not limited to graphics, logos, game designs, animations, and
                        text, is the property of Zonvex or its licensors. Unauthorized use, reproduction, or distribution
                        of this content is prohibited.</p>

                    <h2>Third-Party Content</h2>
                    <p>Zonvex may contain references to cryptocurrency or blockchain technology for thematic purposes
                        only. This does not constitute:</p>
                    <ul>
                        <li>An endorsement of any cryptocurrency</li>
                        <li>Financial or investment advice</li>
                        <li>A recommendation to purchase or trade digital assets</li>
                    </ul>

                    <h2>Limitation of Liability</h2>
                    <p>Zonvex and its operators shall not be held liable for any direct, indirect, incidental, or
                        consequential damages arising from the use of this platform. Users access and use Zonvex at their
                        own discretion and risk.</p>

                    <h2>Changes to This Disclaimer</h2>
                    <p>We reserve the right to modify this disclaimer at any time. Changes will be effective immediately upon
                        posting. Continued use of the platform after changes constitutes acceptance of the modified disclaimer.
                    </p>

                    <h2>Contact Information</h2>
                    <p>If you have any questions or concerns about this disclaimer, please navigate to our contact section on
                        the homepage.</p>
                </div>
            </div>
            <Footer />
        </>

    )
}

export default DisclaimerPage